import logoUrl from '@/assets/lira-logo-256.png'
import { cn } from '@/lib/cn'

/**
 * Klubbmärket. Märket har gul kontur hela vägen runt och fungerar därför
 * lika bra mot blått, vitt och mörk bakgrund utan separata varianter.
 */
export function Crest({ size = 40, className }: { size?: number; className?: string }) {
  return (
    <img
      src={logoUrl}
      width={size}
      height={Math.round(size * (321 / 256))}
      alt=""
      aria-hidden
      className={cn('shrink-0 select-none', className)}
      draggable={false}
    />
  )
}

/** Märke plus ordbild. Används i sidhuvudet och på inloggningssidan. */
export function Logo({
  size = 40,
  subtitle = 'Lirahäftet',
  tone = 'onBrand',
  className,
}: {
  size?: number
  subtitle?: string | null
  tone?: 'onBrand' | 'ink'
  className?: string
}) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <Crest size={size} />
      <span className="flex flex-col leading-none">
        <span
          className={cn(
            'font-display text-base font-extrabold tracking-tight',
            tone === 'onBrand' ? 'text-on-brand' : 'text-ink',
          )}
        >
          Lira BK
        </span>
        {subtitle && (
          <span
            className={cn(
              'mt-0.5 font-display text-xs font-bold tracking-[0.14em] uppercase',
              tone === 'onBrand' ? 'text-accent' : 'text-brand-ink',
            )}
          >
            {subtitle}
          </span>
        )}
      </span>
    </span>
  )
}

/**
 * Klubbmärket som dämpad vattenstämpel bakom innehållet.
 *
 * Märket ritas som det är, men `mix-blend-luminosity` kastar bort dess egna
 * färger och behåller bara ljusheten. Det gula blir ljust, det blå mörkt, och
 * kulören kommer ur den blå bottnen under – en ljusblå logga utan en andra
 * bildfil.
 *
 * Vägen dit gick via att fylla silhuetten med en färg, vilket såg ut som en
 * rundad klump. Sköldens inre teckning är det enda som gör den igenkännlig,
 * och den finns bara kvar om bilden får ritas hel.
 */
export function CrestWatermark({ width, className }: { width: number; className?: string }) {
  return (
    <img
      src={logoUrl}
      alt=""
      aria-hidden
      draggable={false}
      width={width}
      height={Math.round(width * (321 / 256))}
      className={cn('pointer-events-none absolute select-none mix-blend-luminosity', className)}
    />
  )
}
